import { useEffect, useRef, useState } from "react";
import {
  ExcelExport,
  ExcelExportColumn,
} from "@progress/kendo-react-excel-export";
import {
  Grid,
  GridCellProps,
  GridColumn,
  GridColumnMenuFilter,
  GridColumnMenuProps,
  GridDataStateChangeEvent,
  GridExpandChangeEvent,
  GridNoRecords,
} from "@progress/kendo-react-grid";

import {
  setExpandedState,
  setGroupIds,
} from "@progress/kendo-react-data-tools";
import { DataResult, process, State } from "@progress/kendo-data-query";
import { url } from "inspector";
import { SubmitStatus } from "../../core/formik-model-dialog.component";
import { API_END_POINT } from "../../constants";
import { GridCommandCell } from "../../core/grid-command-cell.component";
import { LoadingIndicator } from "../../core/loading-indicator.component";
import {
  DeleteModelDialog,
  DeletePostDataInfo,
  DeleteStatus,
} from "../../core/delete-model-dialog.component";
import EmployeeModel from "../../models/party/employee-model";
import { useGetEmployee } from "../../apiclient/party/useGetEmployeeApi";
import EmployeeEntry from "./employee-entry";
import { GridActionComponent } from "../../core/action.title.component";

export const addOrUpdateArrayItem = (data: any[], item: any, key: string) => {
  const newData = data ? [...data] : [];
  const index = data?.findIndex((d) => d[key] === item[key]);
  console.log("the index is" + index);
  if (index > -1) {
    newData.splice(index, 1, item);
  } else {
    newData.push(item);
  }
  return newData;
};

const EmployeePage: React.FC = () => {
  const initialDataState: State = {
    take: 10,
    skip: 0,
    group: [],
  };
  const [dataState, setDataState] = useState<State>(initialDataState);
  const [deleteEmployeeData, setDeleteEmployeeData] =
    useState<DeletePostDataInfo>();
  const [collapsedState, setCollapsedState] = useState<string[]>([]);
  const [resultData, setResultData] = useState<DataResult>();

  const [editModal, setEditModal] = useState<boolean>(false);
  const [editData, setEditdata] = useState<EmployeeModel>(null);
  const exportExcel = useRef<ExcelExport | null>(null);

  const [pgreset, setpgreset] = useState<boolean>(false);
  const [viewModal, setViewModal] = useState<boolean>(false);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const {
    data: result,
    isLoading,
    isError,
    refetch: reloadEmployee,
  } = useGetEmployee();

  const processWithGroups = (data: EmployeeModel[], dataState: State) => {
    const groups = dataState.group;
    dataState.group = groups;
    const newDataState = process(data, dataState);
    setGroupIds({ data: newDataState.data, group: dataState.group });
    return newDataState;
  };
  const fetchData = async () => {
    try {
      setIsRefreshing(true);
      const { data, error } = await reloadEmployee();
      if (error) {
        console.error("Error reloading:", error);
      } else {
        console.log("Reloaded data:", data);
      }
    } catch (err) {
      console.error("Unexpected error:", err);
    } finally {
      setIsRefreshing(false);
    }
  };

  useEffect(() => {
    fetchData();
    setEditdata(null);
    if (result) {
      setResultData(processWithGroups(result, initialDataState));
    }
  }, [result]);

  let newData: any = null;
  if (resultData) {
    newData = setExpandedState({
      data: resultData.data,
      collapsedIds: collapsedState,
    });
  }

  const onSaveComplete = (status: SubmitStatus, data: EmployeeModel) => {
    setEditdata(null);
    if (status === SubmitStatus.Completed) {
      reloadEmployee();
      setResultData(processWithGroups(newData, dataState));
    }
  };

  const excelExport = () => {
    if (exportExcel.current !== null) {
      exportExcel.current.save();
    }
  };

  const onAddNew = () => {
    setEditModal(true);
    setEditdata(new EmployeeModel());
  };
  const onView = (data: EmployeeModel) => {
    setViewModal(true);
    setEditdata(data);
  };

  const onEdit = (data: EmployeeModel) => {
    setEditModal(true);
    setViewModal(false);
    setEditdata(data);
  };

  const onRemove = (data: EmployeeModel) => {
    const { employeeId } = data;
    console.log(data);
    setDeleteEmployeeData({
      data,
      route: `Employee/DeleteEmployee/${employeeId}`,
      endpoint: API_END_POINT.PARTY,
    });
    reloadEmployee();
  };
  const onDeleteComplete = (status: DeleteStatus, data: EmployeeModel) => {
    if (status === DeleteStatus.Completed) {
      reloadEmployee();
      setResultData(processWithGroups(result, dataState));
    }
    setDeleteEmployeeData(null);
  };
  const ColumnMenu = (props: GridColumnMenuProps) => {
    return (
      <div>
        <GridColumnMenuFilter {...props} expanded={true} />
      </div>
    );
  };

  const CommandCell = (props: GridCellProps) => (
    <GridCommandCell
      {...props}
      edit={onEdit}
      remove={onRemove}
      add={onAddNew}
      idPropertyName="id"
      editPermissionName={null}
      deletePermissionName={null}
      view={onView}
    />
  );

  const onSearch = (e: any) => {
    if (e.target.value.length > 0) {
      const searchKey: string = e.target.value;
      const filteredData = result?.filter(
        (p) =>
          p?.employeeCode?.toLowerCase().includes(searchKey?.toLowerCase()) ||
          p?.name?.toLowerCase().includes(searchKey?.toLowerCase())
      );
      setResultData(process(filteredData, dataState));
    } else {
      setResultData(process(result, dataState));
    }
  };

  const expandChange = (event: GridExpandChangeEvent) => {
    const item = event.dataItem;

    if (item.groupId) {
      const newCollapsedIds = !event.value
        ? [...collapsedState, item.groupId]
        : collapsedState.filter((groupId) => groupId !== item.groupId);
      setCollapsedState(newCollapsedIds);
    }
  };

  const ColumnFormatBoolean = (props: any) => {
    return (
      <td
        {...props.tdProps}
        colSpan={1}
        style={{
          color: "black",
        }}
      >
        {props.children === "true" ? (
          <span style={{ color: "green", fontWeight: "bold" }}>Yes</span>
        ) : (
          <span style={{ color: "red", fontWeight: "bold" }}>No</span>
        )}
      </td>
    );
  };
  const refreshGrid = () => {
    reloadEmployee();
  };
  const dataStateChange = (event: GridDataStateChangeEvent) => {
    const newDataState = processWithGroups(result, event.dataState);
    setResultData(newDataState);
    setDataState(event.dataState);
  };
  const onAddClick = () => {
    setEditModal(true);
    setViewModal(false);
    setEditdata(new EmployeeModel());
  };
  let grid = null;
  if (result) {
    grid = (
      <Grid
        data={newData}
        pageable={{ pageSizes: [10, 20, 50, 100] }}
        total={resultData?.total}
        groupable={true}
        sortable={true}
        onDataStateChange={dataStateChange}
        {...dataState}
        onExpandChange={expandChange}
        columnVirtualization={false}
        resizable={true}
      >
        {/* <GridToolbar className="export-bg">
       
        </GridToolbar> */}
        <GridColumn
          field="employeeCode"
          title="Code"
          columnMenu={ColumnMenu}
        />
        <GridColumn
          field="name"
          title="Name"
          columnMenu={ColumnMenu}
        />
        <GridColumn
          field="employeeTypeName"
          title="Employee Type "
        />
        <GridColumn  field="address" title="Address" />

        {/* <GridColumn
          width={"120px"}
          field="city"
          title="City"
        />
        <GridColumn width={"120px"}
         field="pincode"
          title="Pincode"
           /> */}
        <GridColumn
         
          field="droppingPointName"
          title="Dropping Point "
        />
        <GridColumn  field="unionName" title=" Union Name" />
        <GridColumn
          field="aadharNumber"
          title="Aadhar Number"
        />
     
        <GridColumn
          field="isActive"
          title="Active ?"
          cells={{ data: ColumnFormatBoolean }}
        />
        <GridColumn
          cell={CommandCell}
          title="Action"
          width={"150"}
          groupable={true}
        />

        <GridNoRecords>
          <div className="mt-2" style={{ width: "100%", height: "500px" }}>
            <center>
              <h5>No data found</h5>
            </center>
          </div>
        </GridNoRecords>
      </Grid>
    );
    if (isError) {
      return (
        <div>
          <h4>Error Loadong Page..</h4>
        </div>
      );
    }
    return (
      <>
        <div
          style={{ minHeight: "600px" }}
          className="card p-3 border-0 m-3 sw-shadow radius-15"
        >
          <div>
            <GridActionComponent
              onSearchClick={onSearch}
              addButtonClick={onAddClick}
              excelExportClick={excelExport}
              refreshClick={fetchData}
              title="EMPLOYEE"
              addButtonTooltip="Add Employee"
            ></GridActionComponent>
          </div>

          {editModal && (
            <EmployeeEntry isViewMode = {viewModal} data={editData} onClose={onSaveComplete} />
          )}
          {viewModal && (
            <EmployeeEntry
              isViewMode={true}
              data={editData}
              onClose={onSaveComplete}
            />
          )}
          {deleteEmployeeData && (
            <DeleteModelDialog
              title="Delete Employee"
              deleteData={deleteEmployeeData}
              onClose={onDeleteComplete}
            >
              <div>
                Are you sure you want to delete Employee :{" "}
                <span style={{ fontWeight: "bold" }}>
                  {deleteEmployeeData.data.name}
                </span>
                ?
              </div>
            </DeleteModelDialog>
          )}

          <div>
            <>
            {isRefreshing || isLoading ? (
                <LoadingIndicator isLoading={isRefreshing}></LoadingIndicator>
              ) : (
                <div>
              {grid}
              <ExcelExport
                fileName={"Employee_Page"}
                data={result}
                ref={exportExcel}
              >
                <ExcelExportColumn
                  width={100}
                  field="employeeCode"
                  title="Employee Code "
                />
                <ExcelExportColumn width={100} field="name" title="Name " />
                <ExcelExportColumn
                  width={100}
                  field="employeeTypeName"
                  title="Employee Type Name "
                />

                <ExcelExportColumn
                  width={125}
                  field="address"
                  title="Address"
                />

                <ExcelExportColumn width={170} field="city" title="City" />
                <ExcelExportColumn
                  width={150}
                  field="pincode"
                  title="Pin Code"
                />
                <ExcelExportColumn
                  width={280}
                  field="unionName"
                  title=" Union Name"
                />
                <ExcelExportColumn
                  width={280}
                  field="droppingPointName"
                  title=" Dropping Point Name"
                />
                <ExcelExportColumn
                  width={170}
                  field="panNumber"
                  title="Pan Number"
                />
                <ExcelExportColumn
                  width={170}
                  field="aadharNumber"
                  title="Aadhar Number"
                />
                <ExcelExportColumn
                  width={170}
                  field="rationcardNumber"
                  title="Ration Card Number"
                />

                <ExcelExportColumn
                  width={170}
                  field="isActive"
                  title="Is Active"
                />
              </ExcelExport>
              </div>
              )}
            </>
          </div>
          <div></div>
        </div>
      </>
    );
  }
};
export default EmployeePage;
